import { useEffect, useRef, useState } from "react";
import SvgIcon from "../SvgIcon";
import useClickOutside from "../../hooks/useClickOutside";

const filterOptions = (searchString = "", options, key) => {
  const words = searchString.split(" ");
  const filtered = options.filter((option) => {
    return words.reduce(
      (acc, curr) =>
        acc &&
        option[key] &&
        String(option[key]).toLowerCase().includes(curr.toLowerCase()),
      true
    );
  });
  return filtered;
};

export const SearchDropdown = ({
  handleChange,
  options = [],
  placeholder = "Select an option",
  valueKey = "value",
  value = "",
}) => {
  const inputRef = useRef(null);
  const dropdownRef = useRef(null);
  const [search, setSearch] = useState("");
  const [filteredList, setFilteredList] = useState([]);
  const [searchOpened, setSearchOpened] = useState(false);
  const [currentOptionIndex, setCurrentOptionIndex] = useState(0);
  useClickOutside(
    dropdownRef,
    () => {
      setSearchOpened(false);
    },
    searchOpened
  );
  useEffect(() => {
    search.length > 0
      ? setFilteredList(filterOptions(search, options, valueKey))
      : setFilteredList(options);
  }, [options, search]);
  //select an option
  const onChange = (value) => {
    handleChange(value);
    setSearchOpened(false);
    setSearch("");
  };

  const handleClick = (e) => {
    e.preventDefault();
    if (!searchOpened) {
      setSearchOpened(true);
      focusInput();
    }
  };
  const toggleDropdown = () => {
    setSearchOpened(!searchOpened);
    if (searchOpened) {
      setSearch("");
    }
  };
  const focusInput = () => {
    setTimeout(() => {
      inputRef?.current?.focus();
    }, 500);
  };
  const handleKeyPress = (event) => {
    const { key } = event;

    if (searchOpened) {
      switch (key) {
        case "Escape":
          toggleDropdown();
          break;
        case "ArrowDown":
          moveFocusDown();
          break;
        case "ArrowUp":
          moveFocusUp();
          break;
        case "Enter":
          onChange(filteredList[currentOptionIndex]);
          break;
        default:
          break;
      }
    }
  };

  const moveFocusDown = () => {
    if (currentOptionIndex < filteredList.length - 1) {
      setCurrentOptionIndex(currentOptionIndex + 1);
    } else {
      setCurrentOptionIndex(0);
    }
  };

  const moveFocusUp = () => {
    if (currentOptionIndex > 0) {
      setCurrentOptionIndex(currentOptionIndex - 1);
    } else {
      setCurrentOptionIndex(elements.options.length - 1);
    }
  };
  return (
    <details ref={dropdownRef} role="list" open className="dropdown-img">
      <summary onClick={handleClick}>
        {searchOpened ? (
          <input
            ref={inputRef}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => {
              if (["Enter", "Tab"].includes(e.key)) {
                e.preventDefault();
                e.stopPropagation();
              }
              handleKeyPress(e);
            }}
          />
        ) : (
          <p>{value || placeholder}</p>
        )}
        <SvgIcon
          src={
            searchOpened ? "/img/svg/angle-up.svg" : "/img/svg/angle-down.svg"
          }
        />
      </summary>
      <ul role="listbox" className={searchOpened ? "opened" : ""}>
        {filteredList.map((option, i) => (
          <li
            key={`${i}${option.movementLabel || option.label}`}
            onClick={() => onChange(option)}
            role="option"
            className={currentOptionIndex === i ? "current" : ""}
          >
            <span>{option.movementLabel || option.label}</span>
          </li>
        ))}
      </ul>
    </details>
  );
};
